export default __webpack_public_path__ + "static/media/kikuyu.0f0b2e51.svg";